import { Injectable } from '@angular/core';

import { PageTitleService } from '@alfresco/adf-core';

@Injectable({
  providedIn: 'root',
})
export class WkPageTitleService {
  constructor(private readonly pageTitleService: PageTitleService) {}

  setTitle(value: string = null): void {
    return this.pageTitleService.setTitle(value);
  }
}
